// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rounded-icon {
    border-radius: 50%;
    border: 1px solid black;
    width: 50px; /* Adjust according to your needs */
    height: 50px; /* Adjust according to your needs */
    display: inline-flex;
    justify-content: center;
    align-items: center;
}
/* Chat.css */
.profile {
    width: 50px;
    height: 50px;
    background-color: green;
    color: white;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .chattext {
    font-size: 15px;
    color: #6b7179!important;
 }
 .chatday{
    font-size: 10px;
 }
  .textimg{
    font-size: 12px;
    color:  #979a99;;
  }
  .searchpic{
    /* --bs-success-rgb: 25, 135, 84; */
    background-color:#198754;
    /* width: 36px; */
    height: 36px;
    border-radius: 50%;
  }
  .rectanglesearch {
    border-radius: 0 ;
    background-color:hsl(0deg 0% 93.33%);
    border: none;
  }
  .icon-search{
    position: absolute;
    left: 18px;
    top: 10px;
  }
  .profile {
    border-radius: 50%;
  }
  
  .default-avatar {
    display: inline-block;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #009345;
    color: #fff;
    text-align: center;
    line-height: 50px;
  }
  /* .scrollables {
    overflow-y: auto;
    height: calc(90vh - 100px);
}
.scrollable-list{
    height: 60vh;
    overflow-y: scroll;
    overflow-x: hidden;
} */
.scrollable-list{
  overflow-y: auto;
  height: calc(82vh - 145px);
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 3px; /* Width of the scrollbar */
  }

  /* Customize scrollbar thumb (the draggable handle) */
  &::-webkit-scrollbar-thumb {
    background-color: #888; /* Color of the thumb */
    border-radius: 5px; /* Rounded corners */
  }

  /* Customize scrollbar track when hovered */
  &::-webkit-scrollbar-track:hover {
    background-color: #f0f0f0; /* Change color on hover */
  }

  /* Customize scrollbar thumb when hovered */
  &::-webkit-scrollbar-thumb:hover {
    background-color: #555; /* Change thumb color on hover */
  }
}
/*css*/
.adduser{
    border-radius: 50%;
    width: 36px;
    height: 36px;
    background-color: green;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .searchbar{
    width:40px;
  }
    .group-icon {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      align-self: center;
      font-size: 25px;
  }
    .profile{
      border-radius: 50%;
      height: 50px;
      width: 50px;
    }
    .profile1{
      border-radius: 50%;
      height: 30px;
      width: 30px;
    }
    .profiles{
      width: 50px;
      height:50px;
      border-radius: 50%;
      display: flex;
      /* background-color: #030303; */
      color: white;
      align-items: center;
      justify-content: center;
      align-self: center;
      font-size: 25px;
  }
  .profiles1{
    width: 30px;
    height:30px;
    border-radius: 50%;
    display: flex;
    background-color: #030303;
    color: white;
    align-items: center;
    justify-content: center;
    align-self: center;
    font-size: 25px;
  }
  .chats{
      font-size: 16px;
      color: #6c757d;
      font-weight: 800;
      justify-content: center;
      display: block;
      align-items: start;
      object-fit: fill;
  }
  .last-msg{
      color: #979A99;
      font-size: 16px;
  
  }
  .show-list{
      padding: 8px;
  }
  
  .scrollable1 {
    overflow-y: auto;
    overflow-x: hidden;
    padding-left: 3px; /* Hide horizontal scrollbar */
  }
  
  .scrollable1::-webkit-scrollbar {
    width: 6px;
  }
  
  .scrollable1::-webkit-scrollbar-thumb {
    background-color: #dfdfdf;
  }
  
  .scrollable1::-webkit-scrollbar-track {
    background-color: #e7e7e7ce;
  }
  .first-name{
    font-size: 13px;
    color: #d0d0d0;
  }
  .blueBackgroundShort{
    background-color: #0079ff;
    color: #ffffff;
    text-align: start;
    /* min-width: 370px; Remove or set to auto */
    width: 300px;
    /* margin-left: 444px;  */
    margin-left: auto;
    min-height: 42px;
    font-size: 16px;
    padding: 8px 8px 8px 24px;
    font-family: 'Goldaplay', sans-serif;
    border-radius: 5px;
  }
  .blueBackgroundLong{
    background-color: #0079ff;
    color: #ffffff;
    text-align: start;
    /* min-width: 370px; Remove or set to auto */
    /* margin-left: 340px;  */
    /* width: 300px; */
    max-width: 450px;
    margin-left: auto;
    min-height: 42px;
    font-size: 16px;
    padding: 8px 8px 8px 24px;
    font-family: 'Goldaplay', sans-serif;
    border-radius: 5px;
    word-break: break-word;
  }
  
  /* Green Background */
  .greenBackgroundShort {
    background-color: hsl(158.18deg 37.93% 94.31%);
    color: #979A99;
    text-align: start;
    width: 330px;
    min-height: 42px;
    font-size: 16px;
    padding: 4px 8px 8px 24px;
    font-family: 'Goldaplay', sans-serif;
    display: block;
    border-radius: 5px;
  }
  .greenBackgroundLong{
    background-color: hsl(158.18deg 37.93% 94.31%);
    color: #979A99;
    text-align: start;
    min-width: -moz-fit-content;
    min-width: fit-content;
    min-height: 42px;
    font-size: 16px;
    padding: 4px 8px 8px 24px;
    font-family: 'Goldaplay', sans-serif;
    display: block;
    border-radius: 5px;
    margin-right: 380px;
    word-break: break-word;
  }
  .common-content {
    display: block;
    justify-content: space-between;
    align-items: center;
  }
  .greenBackground1{
    color: #979A99;
    display: block;
  }
  .blueBackground1{
    position:relative;
    left: 438px;
    word-break: break-word;
  }
  
  .cursor-pointer{
    cursor: pointer;
  }
  .employee{
    font-weight: 700;
    background-color: black;
    color: whitesmoke;
    width: 35px !important;
    height: 35px !important;
    border-radius: 50%;
  }
  .commonBorderTop{
    border-top: 1px solid #dee2e6;
    padding: 10px;
  }
  .your-paragraph {
    display: -webkit-box;
    -webkit-line-clamp: 1; /* Limit the number of lines */
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .name-color{
    color: #808080e3
  }
  .home-font1{
    font-size: 13px;
  }
  .unread-count{
    background-color: hsl(145.52deg 97.84% 36.27%);
    width: 20px;
    height: 20px;
    border-radius: 50%;
    color: white;
  }
  .chat-icon{
    color: #009345;
  }
  .form-edit{
    position: relative;
    left: 472px;
  }
  .modal-backdrop {
    -webkit-backdrop-filter: blur(8px);
            backdrop-filter: blur(8px); 
}
.over-infi{
  overflow: hidden !important;
}
.display-input{
display: none;
}
.re-size{
resize: none;

overflow-y: auto;
}
@media screen and (max-width: 576px){
  .chattext{
    font-size: 12px;
  }
  .name-color{
    padding-left: 28px !important; 
  }
  .mobile-pl{
    padding-right: 0px;
  }
  .form-edit{
    left: 0px;
  }
  .greenBackgroundLong{
    margin-right: 15%;
  }
  .blueBackground1 {
    position: relative;
    left: 40px;
}
.home-font1{
  font-size: 10px;
}
}
@media screen and (max-width:992px){
  .name-color{
    padding-left: 10px;
  }
  .searchpic{
    width: 36px;
  }
  .top-padding{
    padding-top: 10px;
  }
}
@media screen and (min-width:992px) and (max-width:1200px){
  .chattext{
    padding-left: 24px;
  }
   .name-color{
    padding-left: 10px !important; 
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/chat/Chat.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,WAAW,EAAE,mCAAmC;IAChD,YAAY,EAAE,mCAAmC;IACjD,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;AACvB;AACA,aAAa;AACb;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,wBAAwB;CAC3B;CACA;IACG,eAAe;CAClB;EACC;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,mCAAmC;IACnC,wBAAwB;IACxB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,oCAAoC;IACpC,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;EACX;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;EACnB;EACA;;;;;;;;GAQC;AACH;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB;IACE,UAAU,EAAE,2BAA2B;EACzC;;EAEA,qDAAqD;EACrD;IACE,sBAAsB,EAAE,uBAAuB;IAC/C,kBAAkB,EAAE,oBAAoB;EAC1C;;EAEA,2CAA2C;EAC3C;IACE,yBAAyB,EAAE,0BAA0B;EACvD;;EAEA,2CAA2C;EAC3C;IACE,sBAAsB,EAAE,gCAAgC;EAC1D;AACF;AACA,MAAM;AACN;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,UAAU;EACZ;IACE;MACE,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,kBAAkB;MAClB,eAAe;EACnB;IACE;MACE,kBAAkB;MAClB,YAAY;MACZ,WAAW;IACb;IACA;MACE,kBAAkB;MAClB,YAAY;MACZ,WAAW;IACb;IACA;MACE,WAAW;MACX,WAAW;MACX,kBAAkB;MAClB,aAAa;MACb,+BAA+B;MAC/B,YAAY;MACZ,mBAAmB;MACnB,uBAAuB;MACvB,kBAAkB;MAClB,eAAe;EACnB;EACA;IACE,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;EACjB;EACA;MACI,eAAe;MACf,cAAc;MACd,gBAAgB;MAChB,uBAAuB;MACvB,cAAc;MACd,kBAAkB;MAClB,gBAAgB;EACpB;EACA;MACI,cAAc;MACd,eAAe;;EAEnB;EACA;MACI,YAAY;EAChB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB,EAAE,8BAA8B;EACnD;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;EAC7B;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,4CAA4C;IAC5C,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,oCAAoC;IACpC,kBAAkB;EACpB;EACA;IACE,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,4CAA4C;IAC5C,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,oCAAoC;IACpC,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA,qBAAqB;EACrB;IACE,8CAA8C;IAC9C,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,oCAAoC;IACpC,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,8CAA8C;IAC9C,cAAc;IACd,iBAAiB;IACjB,2BAAsB;IAAtB,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,oCAAoC;IACpC,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,cAAc;IACd,8BAA8B;IAC9B,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,cAAc;EAChB;EACA;IACE,iBAAiB;IACjB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;EACpB;EACA;IACE,6BAA6B;IAC7B,aAAa;EACf;EACA;IACE,oBAAoB;IACpB,qBAAqB,EAAE,8BAA8B;IACrD,4BAA4B;IAC5B,gBAAgB;EAClB;EACA;IACE;EACF;EACA;IACE,eAAe;EACjB;EACA;IACE,8CAA8C;IAC9C,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,kCAA0B;YAA1B,0BAA0B;AAC9B;AACA;EACE,2BAA2B;AAC7B;AACA;AACA,aAAa;AACb;AACA;AACA,YAAY;;AAEZ,gBAAgB;AAChB;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,UAAU;AACd;AACA;EACE,eAAe;AACjB;AACA;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;GACC;IACC,6BAA6B;EAC/B;AACF","sourcesContent":[".rounded-icon {\n    border-radius: 50%;\n    border: 1px solid black;\n    width: 50px; /* Adjust according to your needs */\n    height: 50px; /* Adjust according to your needs */\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n}\n/* Chat.css */\n.profile {\n    width: 50px;\n    height: 50px;\n    background-color: green;\n    color: white;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .chattext {\n    font-size: 15px;\n    color: #6b7179!important;\n }\n .chatday{\n    font-size: 10px;\n }\n  .textimg{\n    font-size: 12px;\n    color:  #979a99;;\n  }\n  .searchpic{\n    /* --bs-success-rgb: 25, 135, 84; */\n    background-color:#198754;\n    /* width: 36px; */\n    height: 36px;\n    border-radius: 50%;\n  }\n  .rectanglesearch {\n    border-radius: 0 ;\n    background-color:hsl(0deg 0% 93.33%);\n    border: none;\n  }\n  .icon-search{\n    position: absolute;\n    left: 18px;\n    top: 10px;\n  }\n  .profile {\n    border-radius: 50%;\n  }\n  \n  .default-avatar {\n    display: inline-block;\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    background-color: #009345;\n    color: #fff;\n    text-align: center;\n    line-height: 50px;\n  }\n  /* .scrollables {\n    overflow-y: auto;\n    height: calc(90vh - 100px);\n}\n.scrollable-list{\n    height: 60vh;\n    overflow-y: scroll;\n    overflow-x: hidden;\n} */\n.scrollable-list{\n  overflow-y: auto;\n  height: calc(82vh - 145px);\n  overflow-x: hidden;\n  &::-webkit-scrollbar {\n    width: 3px; /* Width of the scrollbar */\n  }\n\n  /* Customize scrollbar thumb (the draggable handle) */\n  &::-webkit-scrollbar-thumb {\n    background-color: #888; /* Color of the thumb */\n    border-radius: 5px; /* Rounded corners */\n  }\n\n  /* Customize scrollbar track when hovered */\n  &::-webkit-scrollbar-track:hover {\n    background-color: #f0f0f0; /* Change color on hover */\n  }\n\n  /* Customize scrollbar thumb when hovered */\n  &::-webkit-scrollbar-thumb:hover {\n    background-color: #555; /* Change thumb color on hover */\n  }\n}\n/*css*/\n.adduser{\n    border-radius: 50%;\n    width: 36px;\n    height: 36px;\n    background-color: green;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .searchbar{\n    width:40px;\n  }\n    .group-icon {\n      width: 50px;\n      height: 50px;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      align-self: center;\n      font-size: 25px;\n  }\n    .profile{\n      border-radius: 50%;\n      height: 50px;\n      width: 50px;\n    }\n    .profile1{\n      border-radius: 50%;\n      height: 30px;\n      width: 30px;\n    }\n    .profiles{\n      width: 50px;\n      height:50px;\n      border-radius: 50%;\n      display: flex;\n      /* background-color: #030303; */\n      color: white;\n      align-items: center;\n      justify-content: center;\n      align-self: center;\n      font-size: 25px;\n  }\n  .profiles1{\n    width: 30px;\n    height:30px;\n    border-radius: 50%;\n    display: flex;\n    background-color: #030303;\n    color: white;\n    align-items: center;\n    justify-content: center;\n    align-self: center;\n    font-size: 25px;\n  }\n  .chats{\n      font-size: 16px;\n      color: #6c757d;\n      font-weight: 800;\n      justify-content: center;\n      display: block;\n      align-items: start;\n      object-fit: fill;\n  }\n  .last-msg{\n      color: #979A99;\n      font-size: 16px;\n  \n  }\n  .show-list{\n      padding: 8px;\n  }\n  \n  .scrollable1 {\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding-left: 3px; /* Hide horizontal scrollbar */\n  }\n  \n  .scrollable1::-webkit-scrollbar {\n    width: 6px;\n  }\n  \n  .scrollable1::-webkit-scrollbar-thumb {\n    background-color: #dfdfdf;\n  }\n  \n  .scrollable1::-webkit-scrollbar-track {\n    background-color: #e7e7e7ce;\n  }\n  .first-name{\n    font-size: 13px;\n    color: #d0d0d0;\n  }\n  .blueBackgroundShort{\n    background-color: #0079ff;\n    color: #ffffff;\n    text-align: start;\n    /* min-width: 370px; Remove or set to auto */\n    width: 300px;\n    /* margin-left: 444px;  */\n    margin-left: auto;\n    min-height: 42px;\n    font-size: 16px;\n    padding: 8px 8px 8px 24px;\n    font-family: 'Goldaplay', sans-serif;\n    border-radius: 5px;\n  }\n  .blueBackgroundLong{\n    background-color: #0079ff;\n    color: #ffffff;\n    text-align: start;\n    /* min-width: 370px; Remove or set to auto */\n    /* margin-left: 340px;  */\n    /* width: 300px; */\n    max-width: 450px;\n    margin-left: auto;\n    min-height: 42px;\n    font-size: 16px;\n    padding: 8px 8px 8px 24px;\n    font-family: 'Goldaplay', sans-serif;\n    border-radius: 5px;\n    word-break: break-word;\n  }\n  \n  /* Green Background */\n  .greenBackgroundShort {\n    background-color: hsl(158.18deg 37.93% 94.31%);\n    color: #979A99;\n    text-align: start;\n    width: 330px;\n    min-height: 42px;\n    font-size: 16px;\n    padding: 4px 8px 8px 24px;\n    font-family: 'Goldaplay', sans-serif;\n    display: block;\n    border-radius: 5px;\n  }\n  .greenBackgroundLong{\n    background-color: hsl(158.18deg 37.93% 94.31%);\n    color: #979A99;\n    text-align: start;\n    min-width: fit-content;\n    min-height: 42px;\n    font-size: 16px;\n    padding: 4px 8px 8px 24px;\n    font-family: 'Goldaplay', sans-serif;\n    display: block;\n    border-radius: 5px;\n    margin-right: 380px;\n    word-break: break-word;\n  }\n  .common-content {\n    display: block;\n    justify-content: space-between;\n    align-items: center;\n  }\n  .greenBackground1{\n    color: #979A99;\n    display: block;\n  }\n  .blueBackground1{\n    position:relative;\n    left: 438px;\n    word-break: break-word;\n  }\n  \n  .cursor-pointer{\n    cursor: pointer;\n  }\n  .employee{\n    font-weight: 700;\n    background-color: black;\n    color: whitesmoke;\n    width: 35px !important;\n    height: 35px !important;\n    border-radius: 50%;\n  }\n  .commonBorderTop{\n    border-top: 1px solid #dee2e6;\n    padding: 10px;\n  }\n  .your-paragraph {\n    display: -webkit-box;\n    -webkit-line-clamp: 1; /* Limit the number of lines */\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  }\n  .name-color{\n    color: #808080e3\n  }\n  .home-font1{\n    font-size: 13px;\n  }\n  .unread-count{\n    background-color: hsl(145.52deg 97.84% 36.27%);\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    color: white;\n  }\n  .chat-icon{\n    color: #009345;\n  }\n  .form-edit{\n    position: relative;\n    left: 472px;\n  }\n  .modal-backdrop {\n    backdrop-filter: blur(8px); \n}\n.over-infi{\n  overflow: hidden !important;\n}\n.display-input{\ndisplay: none;\n}\n.re-size{\nresize: none;\n\noverflow-y: auto;\n}\n@media screen and (max-width: 576px){\n  .chattext{\n    font-size: 12px;\n  }\n  .name-color{\n    padding-left: 28px !important; \n  }\n  .mobile-pl{\n    padding-right: 0px;\n  }\n  .form-edit{\n    left: 0px;\n  }\n  .greenBackgroundLong{\n    margin-right: 15%;\n  }\n  .blueBackground1 {\n    position: relative;\n    left: 40px;\n}\n.home-font1{\n  font-size: 10px;\n}\n}\n@media screen and (max-width:992px){\n  .name-color{\n    padding-left: 10px;\n  }\n  .searchpic{\n    width: 36px;\n  }\n  .top-padding{\n    padding-top: 10px;\n  }\n}\n@media screen and (min-width:992px) and (max-width:1200px){\n  .chattext{\n    padding-left: 24px;\n  }\n   .name-color{\n    padding-left: 10px !important; \n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
